import { graphQLFetch } from "../../../utils";
import { DELETE_BUDGETS } from "../../queries";

export const deleteBudgets =
  ({ pId, cId }, callback) =>
  async (dispatch, getState) => {
    const variables = {
      pId,
      cId,
    };
    const data = await graphQLFetch(
      DELETE_BUDGETS,
      variables,
      "mutation",
      getState,
      { cacheKeys: ["GetBudgetItems"] }
    );
    const { DeleteBudgets } = data || {};
    callback(DeleteBudgets);

    return DeleteBudgets;
  };
